module.exports = __webpack_public_path__ + "static/media/sms.4422a488.svg";